import appApi from '../../../../../api/app-api';
import { toast } from 'react-toastify';
import { PaymentResponse } from '../../../../../api/types/payments/gateway/payment-gateway-response';

export const onPaymentSuccessOperation = async (
  allocationId: number | undefined,
  userId: number,
  pendingPaymentId: number | undefined,
  setLoading: (loading: boolean) => any,
  setPaymentLink: (
    link: (PaymentResponse & { allocationId: number }) | null,
  ) => any,
) => {
  try {
    if (!allocationId || !pendingPaymentId) {
      toast.warn('נסה שוב בעוד מספר רגעים');
    }

    setLoading(true);
    await appApi.notifyPaymentComplete(
      allocationId!,
      userId,
      pendingPaymentId!,
    );
    setLoading(false);
    setPaymentLink(null);
    toast.success('התשלום בוצע בהצלחה');
  } catch (e) {
    console.error(
      `onPaymentSuccessOperation is failed with the allocationId: ${allocationId} userId: ${userId} pendingPaymentId: ${pendingPaymentId} error: ${e}`,
    );
  }
};
